import { MessageSquare } from "lucide-react";

/**
 * Small comment-count badge for photo grid cards (Phase G3).
 *
 * Editorial: cream icon + count on charcoal pill. Hidden when count is 0.
 * Distinguishable from the favorites badge (which uses a heart symbol);
 * here we use the lucide speech-bubble icon, not an emoji.
 */
export default function CommentBadge({ count, onClick, testid }) {
  if (!count || count <= 0) return null;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      data-testid={testid || "comment-badge"}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-stone-900/85 text-[#F5EFE0] text-[10px] tracking-[0.08em] rounded-sm hover:bg-stone-900 transition-colors"
      title={`${count} comment${count === 1 ? "" : "s"}`}
    >
      <MessageSquare className="w-3 h-3" strokeWidth={1.5} />
      <span>{count}</span>
    </button>
  );
}
